export const apiKeyCreateLead = 'api/next/client-registration/leads';
export const defaultUrlCreateLead = 'api/v1/leads';

export const apiKeyCreateLeadReferral = 'api/next/client-registration/leads/by-referral-url';
export const defaultUrlCreateLeadReferral = 'api/v1/leads/by-referral-url';
export const defaultUrlCreateLeadNotAuth = 'api/v1/leads/not-authorized';
export const apiKeyCreateLeadNotAuth = 'api/next/client-registration/leads/not-authorized';

export const apiKeyListLead = 'api/next/leads';
export const defaultUrlListLead = 'api/v1/leads';

export const apiKeyTechAbility = 'api/next/tech-ability';
export const defaultUrlTechAbility = 'api/v1/tech-ability';

export const apiKeyReportByListLead = 'api/next/reports/leads/current-agent';
export const defaultUrlReportByListLead = 'api/v1/reports/leads/current-agent';

export const apiKeyMarketplace = 'api/next/leads/marketplace';
export const defaultUrlMarketplace = 'api/v1/leads/marketplace';
